import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./DevNavbar.css";
import { getUser, logout, AUTH_EVENT } from "../services/auth";

export default function DevNavbar() {
  const [user, setUser] = useState(() => getUser());
  const navigate = useNavigate();

  useEffect(() => {
    const sync = () => setUser(getUser());
    window.addEventListener('storage', sync);
    window.addEventListener(AUTH_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(AUTH_EVENT, sync);
    };
  }, []);

  const role = user?.role;

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="dev-navbar">
      <Container>
        <Navbar.Brand as={Link} to="/admin">⚙️ Panel Administrativo</Navbar.Brand>
        <Navbar.Toggle aria-controls="dev-navbar-nav" className="navbar-toggler-icon orange" />
        <Navbar.Collapse id="dev-navbar-nav">
          <Nav className="me-auto">

            {/* DEV: ve todo salvo Postulantes/Usuarios */}
            {role === 'dev' && (
              <>
                <Nav.Link as={Link} to="/admin/home">🏠 Home</Nav.Link>
                <Nav.Link as={Link} to="/admin/clientes/empresas">🏢 Empresas</Nav.Link>
                <Nav.Link as={Link} to="/admin/clientes/sucursales">📍 Sucursales</Nav.Link>
                <Nav.Link as={Link} to="/admin/servicios/nuevo">🛠️ Servicios</Nav.Link>
                <Nav.Link as={Link} to="/admin/novedades">📰 Novedades</Nav.Link>
              </>
            )}

            {/* ADMIN: solo Users + Postulantes */}
            {role === 'admin' && (
              <>
                <Nav.Link as={Link} to="/admin/users">👤 Usuarios</Nav.Link>
                <Nav.Link as={Link} to="/admin/users/new">👤 Crear Usuarios</Nav.Link>
                <Nav.Link as={Link} to="/admin/postulantes">📄 Postulantes</Nav.Link>
              </>
            )}

            {/* VIEW: solo Postulantes */}
            {role === 'view' && (
              <Nav.Link as={Link} to="/admin/postulantes">📄 Postulantes</Nav.Link>
            )}
          </Nav>

          {user && (
            <span className="ms-3 small text-white-50">
              {user.username} ({user.role})
              <button className="btn btn-link ms-2 p-0 text-decoration-none" onClick={handleLogout}>
                salir
              </button>
            </span>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}


